<template>
  <v-dialog v-model="visible" persistent max-width="700px">
    <v-card>
      <v-card-title class="text-uppercase">{{ titulo }}</v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" style="padding-bottom: 0px !important">
              <vue-select
                v-model="unidad"
                class="style-chooser"
                placeholder="Unidad de medida"
                :options="unidades"
                return-object
                label="text"
                @input="getUnidadMedida">
                <template slot="option" slot-scope="option">
                  <span> {{ option.value }} - {{ option.text }} </span>
                </template>
              </vue-select>

              <small v-for="error in errores.gestion" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-text-field
                class="my-1"
                label="Descripción"
                v-model="form.descripcion"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.descripcion" :key="error" class="text-danger">{{ error }}</small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" text @click.prevent="validar"> Guardar </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="3000">
      Complete los campos

      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>

    <notifications group="notifications" position="top right" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ModalFormMixin from '../mixins/modal-form-mixin';
import UnidadMedidaServices from '../services/unidadMedida';
import { ACCIONES_CRUD, formatearErrores } from '../utils';

export default {
  name: 'ModalFormUnidadMedida',
  mixins: [ModalFormMixin],
  props: ['tipo'],
  data() {
    return {
      snackbar: false,
      unidades: [],
      unidad: null,
    };
  },
  watch: {
    'form.descripcion': function () {
      this.errores.descripcion = [];
    },
    'form.unidad': function () {
      this.errores.unidad = [];
    },
    'form.codigo_unidad': function () {
      this.errores.codigo_unidad = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        descripcion: null,
        unidad: null,
        codigo_unidad: '',
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        descripcion: data.descripcion,
        unidad: data.unidad,
        codigo_unidad: data.codigo_unidad,
      };
    },
    getUnidadMedida() {
      this.form.unidad = this.unidad.text;
      this.form.codigo_unidad = this.unidad.value;
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);

      if (accion == ACCIONES_CRUD.REGISTRAR) {
        this.unidad = null;
      }

      if (accion == ACCIONES_CRUD.EDITAR) {
        this.unidad = {
          value: data.codigo_unidad,
          text: data.unidad,
        };
      }

      this.getUnidades();
    },
    async registrar() {
      this.guardar();
    },
    async editar() {
      this.guardar();
    },
    async guardar() {
      this.enviando = true;
      this.errores = [];

      try {
        let response = null;

        if (this.form?.id) {
          response = await UnidadMedidaServices.update(this.form.id, this.form);
        } else {
          response = await UnidadMedidaServices.store(this.form);
        }

        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: response.data.mensaje,
          type: 'success',
        });
        this.$emit('actualizarListado');
        this.cerrar();
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: `${this.nombreRecurso}: ${mensaje}`,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.enviando = false;
      }
    },
    async getUnidades() {
      try {
        const response = await UnidadMedidaServices.getUnidades();
        const unidades = response.data.map((unidad) => ({
          value: unidad.codigo,
          text: unidad.descripcion,
        }));

        this.unidades = unidades.sort((a, b) => a.value - b.value);
      } catch (err) {
        window.console.log(err);
      }
    },
  },
};
</script>

<style>
.v-dialog {
  align-items: flex-start;
}
</style>